export const STORAGE_KEY = 'QT_LITE_STATE';
export const COMPANY_STORAGE_KEY = 'QT_LITE_COMPANY';
export const LOCALE_STORAGE_KEY = 'QT_LITE_LOCALE';
export const STORE_RESET_KEY = 'QT_LITE_RESET';

/**
 * In course selector tree, the default expanded course node will be the first one
 */
export const DEFAULT_EXPANDED_COURSE_NODE = 0;

export const ACCOMMODATIONS_FALLBACK_IMAGE = '/assets/images/accommodation.jpg';
export const PREMIUM_ACCOMMODATIONS_FALLBACK_IMAGE = '/assets/images/premium-accommodation.png';
export const PREMIUM_ACTIVITIES_FALLBACK_IMAGE = '/assets/images/premium-activity.png';
export const PACKAGE_DETAILS_CONTAINER_ID = 'packageDetails';
